<template>
  <div class="main-page" :class="{ 'half-chat': halfChat }">
    <div v-if="events != null">
      <Countdown
        @update="fetchResource('Countdown')"
        v-if="countdown"
        v-model="countdown"
      />
      <div class="video-chat-section">
        <div class="video-wrapper">
          <div class="video-wrapper__above">
            <b> </b>
          </div>
          <Video
            v-if="activeEvent"
            v-model="activeEvent"
            :key="[activeEvent.vimeo_id, activeEvent.youtube_id].join('_')"
            :first-start-at="firstStartAt"
            :half-chat="halfChat"
          />
        </div>
        <div
          v-show="chat && !chat.hidden"
          v-if="$size != 'xs'"
          class="chat-wrapper"
        >
          <Chat v-model="chat" :reciever="true" />
        </div>
      </div>

      <div v-show="chat && !chat.hidden">
        <div class="show-chat" @click="showChat = !showChat">
          {{ showChat ? "Hide" : "Show" }} Chat
          <v-icon color="white" size="0.95em" steyl="margin-top: -0.25em;">{{
            showChat ? "$caret_up" : "$caret_down"
          }}</v-icon>
        </div>
        <div
          v-if="$size == 'xs'"
          class="chat-wrapper"
          :class="{ opened: showChat }"
        >
          <Chat v-model="chat" />
        </div>
      </div>

      <div class="keynote-speaker" v-if="activePage && !activePage.is_chat_hub">
        <div class="keynote-speaker__agenda">
          <div class="keynote-speaker__agenda-left">
            <span>Event Schedule</span>
          </div>
          <div class="keynote-speaker__agenda-right">
            <router-link class="keynote-speaker__agenda-link" to="/agenda">
              View Full Agenda
            </router-link>
            <v-btn color="#D11947" class="button-ask" @click="openQuestionModal"
              >Ask a Question!</v-btn
            >
          </div>
        </div>
        <QuestionModal v-model="questionModalVisible" />
        <div
          class="active-event"
          v-if="
            activeEvent &&
            activeEvent.speaker &&
            displayEvent &&
            !displayEvent.hidden
          "
        >
          <img
            :src="activeEvent.speaker.preview_urls.original"
            class="active-event__left"
            alt="speaker avatar"
          />
          <div class="active-event__speaker-info-mobile">
            <div class="speaker-info">Keynote Speaker</div>
            <hr />
            <div class="speaker-title">
              {{ activeEvent.speaker.name }}, {{ activeEvent.speaker.title }}
            </div>
          </div>
          <div class="active-event__right">
            <div class="speaker-info">Keynote Speaker</div>
            <hr />
            <div class="speaker-title">
              {{ activeEvent.speaker.name }}, {{ activeEvent.speaker.title }}
            </div>
            <div class="speaker-descriptor">
              {{
                activeEvent.speaker.biography_short ||
                activeEvent.speaker.biography
              }}
            </div>
          </div>
        </div>
      </div>

      <div
        class="timeline-rotator-section"
        v-if="events && events.length > 0"
        :class="{
          'timeline-rotator-section--align-title':
            activeEvent && !activeEvent.hidden,
        }"
      >
        <div class="timeline-rotator-section__info">
          <b>
            Select a thumbnail below to watch posted content. Click the left
            arrow to see pieces posted earlier.
          </b>
          <div>
            <i>
              Note: you can also scroll down the page to view archived content.
              Unfortunately, by policy of the Equal Justice Initiative, we are
              unable to continue to share the keynote address by Bryan
              Stevenson.
            </i>
          </div>
        </div>
        <TimelineRotator
          v-model="activeEventId"
          v-if="events"
          :slides="events"
          :hideTimeline="hideTimeline"
          :displayValue="displayEventId"
        />
      </div>

      <div
        class="speakers-section"
        v-if="
          speakers && speakers.length && activePage && !activePage.is_chat_hub
        "
      >
        <div class="speakers-section__title">Keynote Speakers</div>
        <Speakers :speakers="speakers" />
      </div>

      <div
        class="articles-section"
        v-if="topArticleSections && topArticleSections.length > 0"
      >
        <ArticleSection
          :section="articleSection"
          v-for="articleSection in topArticleSections"
          :key="articleSection.id"
        />
      </div>

      <slot></slot>

      <div
        class="articles-section"
        v-if="articleSections && articleSections.length > 0"
      >
        <ArticleSection
          :section="articleSection"
          v-for="articleSection in articleSections"
          :key="articleSection.id"
        />
      </div>
    </div>
    <Spinner v-else />

    <v-snackbar
      v-if="newVideo"
      class="new-video"
      v-model="newVideo"
      @click="newVideo = false"
      :timeout="600000"
      top
    >
      <div @click="setNewEvent" class="new-video__text">
        <span> New video just posted </span>
        <v-icon color="#e80000">$arrow_right</v-icon>
      </div>
      <div class="new-video__close" @click="newVideo = false">close</div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
const UPDATE_WINDOW = Math.floor(Math.random() * 30000);

export default {
  name: "MainPage",
  props: {
    hideTimeline: Boolean,
    halfChat: Boolean,
  },
  metaInfo: {
    titleTemplate: "%s",
  },
  data() {
    return {
      activeEventId: null,
      activeEvent: null,
      displayEvent: null,
      displayEventId: null,
      showChat: false,
      firstTime: true,
      newVideo: false,
      newEvent: null,
      chat: null,
      firstStartAt: 0,
      questionModalVisible: false,
    };
  },
  mounted() {
    this.fetchData();

    this.$root.$on("setActiveEvent", (event) => {
      this.activeEvent = event;
      this.activeEventId = event.id;
      this.displayEvent = this.activeEvent;
      this.displayEventId = this.activeEventId;

      // if (!this.firstTime) {
      //   const y =
      //     document.querySelector(".video-wrapper").getBoundingClientRect().top +
      //     window.scrollY;

      //   window.scroll({
      //     top: y - 60,
      //     behavior: "smooth",
      //   });
      // }
      this.firstTime = false;

      const route = { ...this.$route };
      if (this.activeEvent.type == "article") {
        route.query = {
          article_id: this.activeEvent.id,
        };
      } else {
        route.query = {
          event_id: this.activeEvent.id,
        };
      }

      this.$router.replace(route);
    });

    this.$root.$on("nextVideo", () => {
      const activeEventIndex = this.events.findIndex(
        (t) => t.id == this.activeEventId
      );
      const displayEventIndex = this.events.findIndex(
        (t) => t.id == this.displayEventId
      );
      const index =
        displayEventIndex > activeEventIndex
          ? displayEventIndex
          : activeEventIndex;
      const nextEvent = this.events[index + 1];
      if (index != -1 && nextEvent && nextEvent.posted) {
        this.activeEvent = nextEvent;
        this.activeEventId = nextEvent.id;
        this.displayEvent = this.activeEvent;
        this.displayEventId = this.activeEventId;
      }
    });

    this.$root.$on("chapterChange", (data) => {
      const index = this.events.findIndex(
        (t) =>
          t.vimeo_id == data.vimeo_id && t.vimeo_chapter == data.vimeo_chapter
      );
      const event = this.events[index];
      if (index != -1 && event) {
        this.displayEvent = event;
        this.displayEventId = event.id;
      }
    });
  },
  methods: {
    setNewEvent() {
      this.activeEventId = this.newEvent.id;
      this.activeEvent = this.newEvent;
      this.displayEvent = this.activeEvent;
      this.displayEventId = this.activeEventId;
      this.$root.$emit("slideToEvent", this.displayEventId);
      this.newVideo = false;
    },
    async fetchData() {
      return Promise.all([
        this.fetchArticles(),
        this.fetchEvents(),
        this.fetchResource("Countdown"),
        this.fetchSpeakers(),
      ]);
    },
    async fetchSpeakers() {
      await this.fetchResource("Speaker");
    },
    async fetchEvents() {
      const events = await this.fetchResource("Event", this.formatEvents);
      let fetchAt = null;

      for (const event of events) {
        if (!event.ready) {
          fetchAt = new Date(event.start_at);
          break;
        }
      }

      for (const event of events) {
        if (!event.posted) {
          const postAt = new Date(event.start_at);

          const timeout = postAt.getTime() - Date.now();
          if (timeout <= 2147483647) {
            setTimeout(() => {
              this.newVideo = true;
              this.newEvent = event;
              this.updateResource("Event", this.formatEvents, this.events);
            }, timeout);
          }
          break;
        }
      }

      if (fetchAt) {
        const timeout = fetchAt.getTime() - Date.now() - UPDATE_WINDOW;
        if (timeout > 0 && timeout <= 2147483647) {
          this.timeout = setTimeout(() => this.fetchEvents(), timeout);
        }
      }

      this.firstStartAt = Date.parse(
        events.find((event) => !event.hidden).start_at
      );
    },
    async fetchArticles() {
      const sections = await this.fetchResource("ArticleSection");
      let fetchAt = null;
      sections.forEach((section) => {
        for (const article of section.articles) {
          if (!article.posted) {
            const newFetchAt = new Date(article.posted_at);
            if (!fetchAt || newFetchAt < fetchAt) {
              fetchAt = newFetchAt;
            }
            break;
          }
        }
      });

      if (fetchAt) {
        const timeout = fetchAt.getTime() - Date.now() + UPDATE_WINDOW;
        if (timeout > 0 && timeout <= 2147483647) {
          this.timeout = setTimeout(async () => {
            await this.fetchArticles();
          }, timeout);
        }
      }
    },
    formatEvents(_events) {
      if (!_events) return null;

      const events = JSON.parse(JSON.stringify(_events));
      const to = events.length - 1;

      for (let i = to; i > 0; i--) {
        events[i].start_at_day = null;
      }

      for (let i = to; i > 0; i--) {
        const posted = new Date() >= new Date(events[i].start_at);

        if (posted) {
          for (let j = i; j > 0; j--) {
            const event = events[j];

            if (event.start_at == events[i].start_at) {
              event.posted = true;
              event.status = "just_posted";
            } else {
              event.status = "earlier";
              break;
            }
          }

          const taggedDates = [];

          for (let j = i + 1; j <= to; j++) {
            const event = events[j];
            const stamp = this.$moment(
              new Date(event.start_at),
              "timezone",
              "America/New_York"
            ).format("MM/DD");

            if (!taggedDates.includes(stamp)) {
              taggedDates.push(stamp);
              event.start_at_day = event.start_at;
            }
          }

          break;
        }
      }
      return events;
    },
    openQuestionModal() {
      this.questionModalVisible = true;
    },
  },
  computed: {
    ...mapState({
      events: (state) => state.page.cache[state.page.active?.id]?.Event,
      speakers: (state) => state.page.cache[state.page.active?.id]?.Speaker,
      topArticleSections: (state) =>
        state.page.cache[state.page.active?.id]?.ArticleSection?.filter(
          function (as) {
            return as.position < 0;
          }
        ),
      articleSections: (state) =>
        state.page.cache[state.page.active?.id]?.ArticleSection?.filter(
          function (as) {
            return as.position >= 0;
          }
        ),
      countdown: (state) => state.page.cache[state.page.active?.id]?.Countdown,
    }),
  },
  beforeDestroy() {
    if (this.timeout) clearTimeout(this.timeout);
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.video-chat-section {
  display: flex;
  position: relative;

  .video-wrapper {
    width: 100%;

    &__above {
      padding: 20px 60px;
      display: none;
    }
    &__below {
    }
  }

  .chat-wrapper {
    width: 300px;
    min-width: 300px;
  }
}

.half-chat {
  .video-chat-section {
    position: relative;
    > .video-wrapper {
      width: 50%;
    }
    .chat-wrapper {
      width: 50%;
      min-width: unset;
      position: relative;
      .chat {
        width: 100%;
      }
    }
  }
  .timeline-rotator-section {
    padding: 0;
    margin: 0;
  }
}

.chat-wrapper::v-deep {
  .chat {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 300px;
  }
}

.show-chat {
  display: none;
  background: $jude-yellow;
  padding: 20px;
  font-family: $body-font-family, sans-serif;
  font-weight: 800;
  font-size: 36px;
  line-height: 36px;
  color: white;
}

.keynote-speaker {
  padding: 0 120px;

  &__agenda {
    padding: 50px 0;
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &-right {
      flex: 1;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      > button {
        margin-left: 30px;
      }
    }

    &-link {
      font-weight: normal;
      margin-left: 30px;
      font-size: 18px;
      line-height: 24px;
      color: #1874dc;
      text-decoration: none;
      flex: 1;
    }
  }
}

.timeline-rotator-section {
  padding: 40px 120px 0;

  &__info {
    display: none;
    padding: 15px 10px;
  }
}

.speakers-section {
  background-color: #f5f5f5;
  padding: 50px 116px;

  &__title {
    font-weight: bold;
    font-size: 43px;
    line-height: 50px;
    margin-bottom: 20px;
  }
}

.main-page {
  position: relative;
}

.articles-section {
  margin-bottom: 50px;
}

.active-event {
  padding: 40px 22px;
  display: flex;
  align-items: flex-start;
  border: 4px solid $jude-darkred;
  border-radius: 10px;

  &__left {
    width: 123px;
    height: 123px;
    object-fit: cover;
    object-position: top center;
    border-radius: 50%;
    margin-right: 28px;
  }
  .speaker-info {
    font-weight: 800;
    font-size: 24px;
    line-height: 30px;
    color: $jude-lightred;
  }
  .speaker-title {
    font-weight: 800;
    font-size: 18px;
    line-height: 24px;
    color: $jude-lightred;
  }
  .speaker-descriptor {
    margin-top: 8px;
    font-size: 14px;
    line-height: 16px;
  }
  &__speaker-info-mobile {
    display: none;
    width: calc(100% - 151px);
    position: relative;
    hr {
      width: 100%;
      height: 4px;
      border-radius: 2px;
      background-color: $jude-gold;
      margin: 10px 0 !important;
    }
    .speaker-title {
      font-weight: 600;
    }
  }
  &__right {
    flex: 1;
    hr {
      width: 210px;
      height: 4px;
      background-color: $jude-gold;
      border-radius: 2px;
      margin: 10px 0;
    }
  }
}

.active-event__content {
  font-weight: 900;
  font-size: 36px;
  line-height: 45px;
  letter-spacing: -0.02em;
  text-transform: capitalize;
}

.active-event__timestamp {
  color: $primary;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.new-video {
  margin-top: -60px;

  &__text {
    font-family: $body-font-family;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: $primary;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    padding-left: 20px;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }

    .v-icon {
      margin: 0 0 0.12em 0.25em;
    }
  }

  &__close {
    font-family: $body-font-family;
    font-weight: 600;
    color: #4a4a4a;
    padding: 0 11px;
    border-left: 1px solid #c4c4c4;
    height: 100%;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  }

  &::v-deep {
    .v-snack__wrapper {
      background: white;
      border-radius: 20px;
      min-width: 300px;
      overflow: hidden;
      margin: 6px;
    }

    .v-snack__content {
      padding: 0;
    }
  }
}

@media screen and (max-width: 1264px) {
  .active-event {
    padding: 20px;
  }
  .timeline-rotator-section {
    &__info {
      padding: 15px 20px;
    }
  }
}

@media screen and (max-width: 960px) {
  .timeline-rotator-section {
    padding: 50px 20px;
    margin-top: -40px;
  }
  .chat-wrapper {
    position: relative;
    height: 0px;
    width: 100% !important;
    transition: 0.3s;

    &.opened {
      height: 500px;
      &::v-deep .chat {
        border-color: #e7e7e7;
        opacity: 1;
      }
    }

    &::v-deep .chat {
      width: 100%;
      border-color: transparent;
      border-left: none;
      border-right: none;
      border-top: none;
      transition: 0.3s;
      opacity: 0;
    }
  }

  .show-chat {
    display: block;
  }

  .video-chat-section {
    display: block;
  }

  .active-event {
    padding: 20px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: end;

    &__content {
      font-size: 1.7em;
    }

    &__speaker-info-mobile {
      display: block;
    }
    &__right {
      flex-basis: 100%;
      .speaker-info,
      hr,
      .speaker-title {
        display: none;
      }
    }
    &__left {
      margin-bottom: 1em;
    }
  }

  .half-chat {
    .video-chat-section {
      > .video-wrapper {
        width: 100%;
      }
    }
  }

  .keynote-speaker__agenda {
    &-left {
      margin-bottom: 10px;
    }
    &-right {
      flex-direction: row-reverse;
      align-items: baseline;
      &::v-deep {
        .v-btn:not(.v-btn--round).v-size--default.button-ask {
          font-size: 16px;
          height: 36px;
          padding: 0 22px;
        }
      }
    }
    &-link {
      font-size: 14px;
      flex: 1;
    }
  }

  .keynote-speaker__agenda {
    padding: 30px 0;
    font-size: 40px;
    display: block;

    &-left {
      display: flex;
      flex-direction: column;
    }
  }
  .keynote-speaker {
    padding: 0 17px;
  }
  .keynote-speaker__agenda-link {
    margin-left: 0;
  }

  .speakers-section {
    background-color: #f5f5f5;
    padding: 17px 20px 15px;
  }
}
</style>
